import { render, staticRenderFns } from "./Headers.vue?vue&type=template&id=976ad702"
import script from "./Headers.vue?vue&type=script&lang=js"
export * from "./Headers.vue?vue&type=script&lang=js"
import style0 from "./Headers.vue?vue&type=style&index=0&id=976ad702&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports